import api, { type RequestBody } from ".";
import type { PaginatedList } from "src/types/api";
import type { BankAccount } from "src/types/account";
import type { SettlementTransactionRow } from "src/types/settlement";

/** A bank from `GET /banks/:country`. */
export interface Bank {
	code: string;
	name?: string;
}

export const getBanks = (country = "NG") => api.get<Bank[]>(`/banks/${country}`);

export const validateAccount = (params: { accountNumber: string; bankCode: string }) =>
	api.get<{ accountName?: string }>("/banks/validate-bank-account", { params });

export const addAccount = (data: RequestBody) => api.post("/banks", data);

export const updateAccount = ({ uuid, ...data }: { uuid?: string } & RequestBody) => api.patch(`/banks/${uuid}/update`, data);

export const getAccounts = () => api.get<BankAccount[]>("/banks");

export const getDisabledAccounts = () => api.get<BankAccount[]>("/banks/disabled");

export const disableAccount = ({ uuid }: { uuid: string }) => api.patch(`/banks/${uuid}/disable`);

export const enableAccount = ({ uuid }: { uuid: string }) => api.patch(`/banks/${uuid}/enable`);

export const getSettlementTransactions = ({ uuid, ...params }: { uuid: string } & RequestBody) =>
	api.get<PaginatedList<SettlementTransactionRow>>(`/banks/${uuid}/transactions`, { params });
